<template>
  <modal name="retouch-modal" :height="420" :clickToClose="false" @before-open="beforeOpen">
    <div class="kt-portlet">
      <div class="kt-portlet__head">
        <div class="kt-portlet__head-label">
          <h3 class="kt-portlet__head-title">Retouch</h3>
        </div>
      </div>
      <div class="kt-portlet__body h-84 overflow-y-auto">
        <div class="row">
          <div class="col-lg-6" v-for="retouchType in retouchTypes" :key="retouchType.id">
            <img width="80%" :src="retouchType.sample" alt/>
            <div class="mt-3">
              <label class="d-flex">
                <input type="radio" :value="retouchType.id" v-model="retouching" />
                <h5 class="ml-2">
                  {{ retouchType.title }}
                  <small class="ml-1">(${{ retouchType.price }})</small>
                </h5>
              </label>
            </div>
          </div>
        </div>
      </div>
      <div class="kt-portlet__foot">
        <div class="kt-form__actions kt-form__actions--right">
          <div class="row">
            <div class="col kt-align-left">
              <button type="button" class="btn btn-success" @click.prevent="reset">Reset</button>
            </div>
            <div class="col kt-align-right">
              <button type="button" class="btn btn-secondary" @click.prevent="close">Close</button>
              <button type="button" class="btn btn-brand ml-2" @click.prevent="save">Save</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  data() {
    return {
      retouching: null,
    };
  },
  computed: {
    ...mapGetters({
      retouchTypes: 'service/retouchTypes',
      orderAddOns: 'order/addOns',
    }),
  },
  methods: {
    save() {
      this.$emit('retouch', this.retouching);

      this.$modal.hide('retouch-modal');
    },
    close() {
      this.$emit('close');

      this.$modal.hide('retouch-modal');
    },
    reset() {
      this.retouching = null;
    },
    beforeOpen() {
      if (this.orderAddOns.retouch) {
        this.retouching = this.orderAddOns.retouch;
      } else {
        this.retouching = null;
      }
    },
  },
};
</script>

<style>
.h-84 {
  height: 21rem !important;
}
.overflow-y-auto {
  overflow-y: auto;
}
input[type='radio'] {
  position: relative;
  display: inline-block;
  width: 20px;
  height: 20px;
  border-radius: 100%;
  outline: none !important;
  -webkit-appearance: none;
}
input[type='radio']::before {
  position: relative;
  top: -1px;
  left: -1px;
  display: block;
  content: '';
  background: white;
  border: 1px solid rgba(128, 128, 128, 0.4);
  border-radius: 100%;
  box-shadow: inset 0 0.1em 1px -0.1em rgba(0, 0, 0, 0.3);
  width: 22px;
  height: 22px;
}
input[type='radio']:active::before {
  box-shadow: inset 0 0.1em 1px -0.1em rgba(0, 0, 0, 0.3),
    inset 0 0 2px 3px rgba(0, 0, 0, 0.1);
}
input[type='radio']:focus::before {
  box-shadow: inset 0 0.1em 1px -0.1em rgba(0, 0, 0, 0.3),
    0 0 0 2px rgba(30, 144, 255, 0.5);
}
input[type='radio']:checked::before {
  background: #a5d3ff;
  border-color: dodgerblue;
}
input[type='radio']:disabled::before {
  cursor: not-allowed;
  background-color: #eaeaea;
  border-color: rgba(128, 128, 128, 0.2);
}
input[type='radio']::after {
  position: relative;
  top: -17px;
  left: 15px;
  display: block;
  content: '';
  background: dodgerblue;
  border-radius: 100%;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
  width: 0;
  height: 0;
}
input[type='radio']:checked::after {
  -webkit-transition: all ease-in-out 100ms 0;
  transition: all ease-in-out 100ms 0;
  top: -18px;
  left: 4px;
  width: 12px;
  height: 12px;
}
input[type='radio']:disabled::after {
  background: #cccccc;
}
</style>
